<template>
<div class="popup" v-show="syncOptionShow" v-cloak>
    <div class="content" id="taskSyncOptions" >
        <div class="title">
            {{$t('language.common.options')}}
            <div class="icon white-close dialog-close" @click="optionClose()"></div>
        </div>
        <div class="transfer-options-body">
            <div class="transfer-options-cont">
                <el-tabs v-model=activeName>
                    <el-tab-pane :label="$t('language.popup.syncModes')" name="first">
                        <tab1 ref="tab1"></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.email')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label" name="third" class="transfer-vip">
                            <span>{{$t('language.popup.filter')}}</span>
                            <div class="icon-util vip filter-position"></div>
                        </span>
                        <tab3 ref="tab3"></tab3>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="transfer-options-footer">
                <button style="float:right;" @click="optionSubmit()">{{$t('language.common.save')}}</button>
                <button class="white-button" style="float:right;margin-right: 10px;" @click="optionClose()">{{$t('language.common.cancel')}}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import '@/assets/css/transfer_options.css'
import tab1 from "@/components/common/tabs/tabs_transfer_options/tab_sync";
import tab2 from "@/components/common/tabs/tabs_transfer_options/tab_email";
import tab3 from "@/components/common/tabs/tabs_transfer_options/tab_filter";
import commonUtils from "@/js/workspace/common_util.js";
import taskTransferUtils from '@/js/workspace/task_transfer_util.js';
import commonstate from '@/js/constant.js';
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    data: function () {
        return {
            activeName: "first",
            syncOptionShow: false,
            tabs: [{
                name: this.$t('language.popup.syncModes')
            }, {
                name: this.$t('language.popup.email')
            }, {
                name: this.$t('language.popup.filter')
            }],
            indexCurrent: 0,
            tabBarClass: '',
            options: {
                way: 10,
                isChar: 1,
            },
            oldOptions: {},
            item: '',
            itemIndex: -1,
            realTimeNotChange:false,//true表示是从即时同步切到即时同步
        };
    },
    methods: {
        optionSubmit() {
            let that=this;
            this.realTimeNotChange=false;
            //提交
            let payWayArr = [11, 12, 13, 14, 15, 16];
            //保存用户所选择的数据
            delete this.options.matched;
            delete this.options.pattern;
            let user = commonUtils.getUser();
            if (payWayArr.includes(this.options.way)) {
                //付费功能弹窗提醒
                if (!user.vip) {
                    var upgradeNewDialog = this.$parent.$refs.upgradeDialog;
                    upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_modes');
                    upgradeNewDialog.curItem = 'modes';
                    upgradeNewDialog.isShow = true;
                    return false;
                }
            }
            if (!this.$refs.tab2.email && this.$refs.tab2.sendShow) {
                this.indexCurrent = 1;
                this.activeName = 'second';
                this.$refs.tab2.shakeBox = "email-shake";
                setTimeout(() => {
                    this.$refs.tab2.shakeBox = "box-shakeOrigin";
                }, 200);
            } else {
                if (this.$refs.tab2.email) {
                    if (!commonstate.emailpattern.test(this.$refs.tab2.email)) {
                        this.activeName = 'second';
                        this.$toast({
                            text: this.$t('language.login.enterCorrectEmai'),
                            type: 'fail',
                            idValue: "taskSyncOptions"
                        });
                        return false;
                    }
                    this.options.email = this.$refs.tab2.email;
                } else {
                    delete this.options.email;
                }
                //用户保存filter数据
                if (this.$refs.tab3.items.length) {
                    // 付费功能弹窗提醒
                    if (!user.vip) {
                        var upgradeNewDialog = this.$parent.$refs.upgradeDialog;
                        upgradeNewDialog.title = this.$t('language.paySystem.freePlanPopup.title_filter');
                        upgradeNewDialog.curItem = 'filter';
                        upgradeNewDialog.isShow = true;
                        return false;
                    }
                    if (this.$refs.tab3.radioCurrent == 0) {
                        this.options.pattern = 'exclude';
                    } else if (this.$refs.tab3.radioCurrent == 1) {
                        this.options.pattern = 'include';
                    }
                    for (let i = 0; i < this.$refs.tab3.items.length; i++) {
                        if (this.options.matched) {
                            this.options.matched = this.options.matched + '*' + this.$refs.tab3.items[i] + '|';
                        } else {
                            this.options.matched = '*' + this.$refs.tab3.items[i] + '|';
                        }
                    }
                    let index = this.options.matched.lastIndexOf('|');
                    this.options.matched = this.options.matched.substring(0, index);
                }
                that.updateOptionRequest(function(res){
                    if(res){
                         that.changeType(function(result){
                             if(result){
                                //当用户出现这种操作的时候（即时/普通单向  -> 即时双向   即时/普通双向 -> 即时单向），就得多调一下这个接口
                                if(that.realTimeNotChange && ((that.options.way==20&&that.item.options.way!=20)||(that.options.way!=20&&that.item.options.way==20))){
                                //更改即时同步监控
                                that.changeRealTimeMonitor();
                                }
                             }
                         });
                    }
                });
                // this.changeType(function(res){
                //     if(res){
                //        that.item.type=2;
                //        that.updateOptionRequest();
                //     }
                // });
            }
        },
        switchType(item,callback){
             let switchData={
                          id:item.id,
                          ud:commonUtils.getUser().id,
              }
            this.Utils.doRealtimeSyncRequest('switch_type',switchData).then(res => {
                   if(res.status!=200){
                     this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                       callback(res);
                   }else{
                       callback(res);
                   }
            });
        },
        changeRealTimeMonitor(){
        let item = this.item;
        let changeData={
                          id:item.id,
                          ud:commonUtils.getUser().id,
                }
         this.Utils.doRealtimeSyncRequest('change1or2',changeData).then(res => {
                   if(res.status!=200){
                     this.$toast({
                        text: this.$t('language.exception.' +res.reason),
                        type: 'fail',
                        idValue: "rightContBan"
                    });
                   }
            });

        },
        changeType(callback){
            let that = this;
            if(this.item.branchType=='realtime'){
               if(!this.$refs.tab1.realTimeMode){//如果将即时任务模式改为普通模式
                this.switchType(this.item,function(res){
                    if(res.status==200){
                    that.item.status=res.data.status;
                    that.$parent.taskListOriginal[that.itemIndex].status=res.data.status;
                    that.item.type=2;
                    if(that.item.viewed){
                    delete that.item.viewed;
                    }
                    that.item.syncOptionShow=false;
                    delete that.item.result;
                    delete that.item.branchType;
                    delete that.$parent.taskListOriginal[that.itemIndex].branchType;
                    that.$parent.showTaskStatus();
                    callback(res);
                    }else{
                    callback(false);
                    }
                });
                // if(this.item.sources){
                //   $.each(this.item.sources,function(j,jItem){
                //      that.switchType(jItem,function(res){
                //       if(res.status==200){
                //        jItem.status=res.data.status;
                //      if(that.item.sources){
                //     $.each(that.$parent.$parent.taskListOriginal[that.itemIndex].sources,function(k,kItem){
                //         delete jItem.result;
                //         jItem.status=res.data.status;
                //       })
                //      }
                //     that.item.type=2;
                //     that.item.syncOptionShow=false;
                //     delete that.item.branchType;
                //     delete that.item.result;
                //     delete that.$parent.$parent.taskListOriginal[that.itemIndex].branchType;
                //     delete that.$parent.$parent.taskListOriginal[that.itemIndex].result;
                //     that.$parent.showTaskStatus();
                //        callback(res);
                //       }
                //      });
                //   });
                // }
              }else{//如果还是即时同步状态
                this.realTimeNotChange=true;
                 callback(true);
              }
            }else{
             if(this.$refs.tab1.realTimeMode){//从普通模式将任务改为即时同步模式
             if(this.item.toItem.driveType=='box' && this.item.toItem.nodes.length<2){
                this.$toast({
                text: this.$t('language.exception.InvalidDirectory'),
                type: 'fail',
                idValue: 'rightContBan',
                learnMoreShow: false
               });
               callback(false);
               return;
             }
             if(this.item.fromItem.driveType=='box' && this.item.fromItem.nodes.length<2){
                this.$toast({
                text: this.$t('language.exception.InvalidDirectory'),
                type: 'fail',
                idValue: 'rightContBan',
                learnMoreShow: false
               });
               callback(false);
               return;
             }
             // if(!commonstate.supportRealTimeDrives.includes(this.item.fromItem.driveType)){
             //    this.$toast({
             //    text: this.$t('language.exception.notOpened'),
             //    type: 'fail',
             //    idValue: 'rightContBan',
             //    learnMoreShow: false
             //   });
             //   callback(false);
             //   return;
             // }
             this.switchType(that.item,function(res){
                 if(res.status==200){
                     that.$parent.$parent.taskListOriginal[that.itemIndex].status=res.data.status;
                      callback(res);
                      that.item.branchType='realtime';
                      that.$parent.$parent.taskListOriginal[that.itemIndex].branchType='realtime';
                      that.$parent.$parent.taskListOriginal[that.itemIndex].status=res.data.status;
                      that.$parent.showTaskStatus();
                      if(res.data.status=='Init'){
                           that.$parent.getSingleRealTimeProgress(that.$parent.$parent.taskListOriginal[that.itemIndex]);
                      }
                 }else{
                      callback(false);
                 }
             });
             }else{//表明从普通到普通模式
            callback(true);
             }
            }
        },
        updateOptionRequest(callback) {
            let that = this;
            var updateData;
            let item = this.item;
            let options = this.options;
            let getData;
           
            if (this.item.isMultiTask) {
                let gd = this.item.id;
                updateData = new taskTransferUtils.updateGdTaskData(gd, commonUtils.getUser().id, this.item.type, this.item.name, options, null);
            } else {
                let id = this.item.id;
                updateData = new taskTransferUtils.updateIdTaskData(id, commonUtils.getUser().id, this.item.type, this.item.name, options,null);
            }
            that.syncOptionShow = false;
            that.$parent.$forceUpdate();
            this.Utils.doTasksRequest("update", updateData).then(result => {
               callback(result);
               if (result.status == 200) {
                    let data = that.$parent.taskListOriginal[that.itemIndex];
                    data.options = options;
                    if(that.oldOptions.way!=that.options.way){
                        data.result = null;
                        data.status = 0;
                    }
                    data.updateFlag = false;
                    that.$parent.taskListOriginal[that.itemIndex] == data;
                    
                } else {
                    this.$toast({
                        text: this.$t('language.exception.' + result.reason),
                        type: 'fail',
                        idValue: "syncOptions"
                    });
                }
            });
        },
        optionClose() {
            //还原用户之前选择的数据
            this.syncOptionShow = false;
            this.$refs.tab1.listNormalOpen=false;
            this.$refs.tab1.$refs.selectrealTime.listNormalOpen=false;
        },
        caseOption(number) {
            switch (number) {
                case 20:
                    this.$refs.tab1.selectTwoShow = false;
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t('language.popup.twowaySync');
                    break;
                case 10:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.simpleSync');
                    break;
                case 11:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.mirrorSync');
                    break;
                case 12:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.moveSync');
                    break;
                case 13:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.cmuSync');
                    break;
                case 14:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.updateSync');
                    break;
                case 15:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.increSync');
                    break;
                case 16:
                    this.$refs.tab1.$refs.selectOne.currentValue = this.$t("language.popup.onewaySync");
                    this.$refs.tab1.$refs.selectTwo.currentValue = this.$t('language.popup.fullSync');
                    break;
            }
        },
        chooseChar(number) {
            if (number == 1) {
                this.$refs.tab1.isActive = true;
            }
            if (number == 0) {
                this.$refs.tab1.isActive = false;
            }
        }

    }
}
</script>

<style>
.sync-tabs-label {
    margin-right: 40px;
    /*no*/
    float: left;
    font-size: 14px;
    /*no*/
    color: #6f7886;
}

#taskSyncOptions {
    width: 680px;
    /*no*/
    height: 510px;
    /*no*/
}

#taskSyncOptions .transfer-options-body {
    height: 440px;/*no*/
}

#taskSyncOptions #tab-2,
#taskSyncOptions #tab-first,
#taskSyncOptions #tab-second,
#taskSyncOptions #tab-third {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
}

#tab-second {
    margin-left: 0 !important;
}

.is-top {
    margin: 0 !important;
}

#taskSyncOptions .el-tabs__content {
    height: 250px !important;
    /*no*/
    position: relative;
    width: 100%;
    font-size: 14px;
    /*no*/
    color: #6f7886;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 30px;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/task_sync_options_popup.vue